import {ID_BY_RANK, SENIOR_COACH} from '/enum/rank.enum';
import {FETCH_COACH_RANK_PROGRESSION} from '/enum/request.enum';

/**
 * Generates a callback to be called when info icon is pressed, sends tealium tracking and onInfoIconPress callback
 *
 * @param {object} params - Parameters
 * @param {function} params.showRecordPopover - A callback to show popover
 * @param {function} params.recordsShowPopover - A callback to show popover
 * @param {function} params.recordsShowRecord - A callback to show record
 *
 * @returns {function} - Callback - A function to be called when item is pressed
 */
import {ReportProps} from '../Report.types';

export function generateOnRecordPress({
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
}: ReportProps) {
  return ({id}: any) =>
    showRecordPopover([id], {
      recordsShowPopover,
      recordsShowRecord,
      recordExtras: {
        rankProgression: {
          endpoint: FETCH_COACH_RANK_PROGRESSION,
          params: [id, ID_BY_RANK[SENIOR_COACH]],
        },
      },
    });
}
